import { useMemo } from 'react';
import usePortfolioBalance from './usePortfolioBalance';

/**
 * Coins from coin_rate_changes with user balances, sorted for withdrawal picker.
 */
export function useWithdrawalCoinOptions() {
  const {
    coinRates,
    getCoinUnits,
    getCoinUsd,
    formatUsd,
    formatCryptoAmount,
    getPriceUsd,
  } = usePortfolioBalance();

  const coinOptions = useMemo(() => {
    return coinRates
      .map((c) => ({
        symbol: c.symbol,
        name: c.name,
        units: getCoinUnits(c.symbol),
        usdBalance: getCoinUsd(c.symbol),
        priceUsd: getPriceUsd(c.symbol),
      }))
      .sort((a, b) => {
        const aHas = a.units > 0.00000001;
        const bHas = b.units > 0.00000001;
        if (aHas && !bHas) return -1;
        if (!aHas && bHas) return 1;
        return b.usdBalance - a.usdBalance;
      });
  }, [coinRates, getCoinUnits, getCoinUsd, getPriceUsd]);

  const estimateCoinDeduction = (symbol, usdAmount) => {
    const usd = parseFloat(usdAmount) || 0;
    const price = symbol ? getPriceUsd(symbol) : 0;
    if (!symbol || usd <= 0 || price <= 0) {
      return { coinAmount: 0, priceUsd: price };
    }
    return { coinAmount: usd / price, priceUsd: price };
  };

  return {
    coinOptions,
    estimateCoinDeduction,
    formatUsd,
    formatCryptoAmount,
    getCoinUnits,
    getCoinUsd,
    coinRates,
  };
}

export default useWithdrawalCoinOptions;
